import actions from "@/store/modules/bank-account/actions";
import mutations from "@/store/modules/bank-account/mutations";
import state from "@/store/modules/bank-account/state";

export default {
    actions,
    mutations,
    state
}